import { store } from '../store';
import { addFile } from '../helpers';
import {
    IMessage,
    IResultMessage,
    MessageType,
    ProgressBarState,
    ProgressMessage,
    ResultFileMessage
} from './api.type';
import { downloadSlice, uplooadsSlice } from '../store/features/progress/progressSlicer';
import { setAppStepAction, setPropsAction } from '../store/features/context/actions';

const updateProgress = async (message: ProgressMessage, download: boolean) => {
    const { dispatch } = store;
    const slicer = download ? downloadSlice : uplooadsSlice;
    switch (message.state) {
        case ProgressBarState.NEW: {
            dispatch(slicer.actions.add({ id: message.id, filename: message.filename }));
            break;
        }
        case ProgressBarState.IN_PROGRESS: {
            dispatch(slicer.actions.update({ id: message.id, progress: message.progress }));
            break;
        }
        case ProgressBarState.DONE: {
            dispatch(slicer.actions.delete(message.id));
            break;
        }
        case ProgressBarState.ERROR: {
            dispatch(slicer.actions.error({ id: message.id, message: message.error }));
            break;
        }
    }
};

export const RegisterMessageEventListener = () =>
    window.addEventListener('message', async ev => {
        const data = ev.data as IMessage;

        switch (data.type) {
            case MessageType.ADD_FILE: {
                const { desc } = data;
                await addFile(desc.file, desc.id, desc.file.name ?? desc.filename, desc.file.size, desc.refId);
                break;
            }
            case MessageType.DOWNLOAD: {
                await updateProgress(data.desc, true);
                break;
            }
            case MessageType.UPLOAD: {
                await updateProgress(data.desc, false);
                break;
            }
            case MessageType.MODE: {
                store.dispatch(setAppStepAction(data.desc.mode));
                break;
            }
            case MessageType.PROPS: {
                store.dispatch(setPropsAction(data.desc));
                break;
            }
        }
    });

const postMessage = (message: IResultMessage) => window.top?.postMessage(message, '*');

export const requestUploadNewFiles = (newFiles: ResultFileMessage) =>
    postMessage({
        type: MessageType.NEW_FILE,
        desc: newFiles
    });

export const closeWizard = () =>
    postMessage({
        type: MessageType.DONE,
        desc: {}
    });
